import { render, staticRenderFns } from "./edit-doctor.vue?vue&type=template&id=fd48a210&scoped=true&"
import script from "./edit-doctor.vue?vue&type=script&lang=js&"
export * from "./edit-doctor.vue?vue&type=script&lang=js&"
import style0 from "./edit-doctor.vue?vue&type=style&index=0&id=fd48a210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd48a210",
  null
  
)

export default component.exports